export const pageMap = {
  merchant: 'tts_merchants_main_page',
  business: 'tts_portal_main_page',
  affiliate: 'tts_portal_affiliate_page',
  creator: 'tts_portal_creators_page',
  partner: 'tts_portal_partners_page',
  'outstanding-partners': 'tts_portal_outstanding_partners',
  ['privacy-policy']: 'tts_portal_privacy_policy_page',
  newsroom_page: 'newsroom_page',
  newsroom_detail_page: 'newsroom_detail_page',
  'partner-center': 'tts_portal_partner_center'
};
export const regionMap = {
  zh: 'CHINA',
  id: 'ID',
  en: 'GB',
  th: 'TH',
  my: 'MY',
  ph: 'PH',
  vn: 'VN',
  sg: 'SG'
};
export const PAGE_SHOW_EVENT = 'page_show';
export const BUTTON_CLICK_EVENT = 'button_click';
export const PAGE_DURATION_EVENT = 'page_duration';